import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {SurveyResearchModel} from '../views/models/survey-research.model';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SurveyResearchService {
  survey_research_change$ = new BehaviorSubject<SurveyResearchModel[]>([]);
  hotel_survey_change$ = new BehaviorSubject<SurveyResearchModel[]>([]);
  all_survey_change$ = new BehaviorSubject<SurveyResearchModel[]>([]);
  filtered_result_change$ = new BehaviorSubject<SurveyResearchModel[]>([]);

  constructor(private httpClient: HttpClient) {
  }

  getSurveyResearch(mood ?: string) {
    this.httpClient.get(environment.baseURL + '/v2/api' + '/survey').subscribe(
      (resp: SurveyResearchModel[]) => {
        resp.forEach(x => x.rate_date = new Date(x.rate_date));
        const hotelSurvey = resp.filter(x => x.request_id == 0 && x.item_id == 0 && x.survey_header_id == 0);
        this.hotel_survey_change$.next(hotelSurvey);
        this.survey_research_change$.next(resp);
        this.filterData('week');
        this.filterAllSurveyData('today', mood);
      }
    );
  }

  getSurvey(request_id) {
    return this.httpClient.get<SurveyResearchModel>(environment.baseURL + '/v2/api' + '/survey/' + request_id);
  }

  filterAllSurveyData(internal: string, guest: string, rate?: number) {
    let filteredData: SurveyResearchModel[] = this.survey_research_change$.getValue();

    if (guest == 'happy') {
      filteredData = filteredData.filter(x => x.rate == 4 || x.rate == 5);
    } else if (guest == 'unhappy') {
      filteredData = filteredData.filter(x => x.rate == 1 || x.rate == 2);
    }

    let date: Date = new Date();
    if (internal == 'week') {
      date = new Date(date.setDate(date.getDate() - 7));
    } else if (internal == 'month') {
      date = new Date(date.setDate(date.getDate() - 30));
    } else if (internal == 'yesterday') {
      date = new Date(date.setDate(date.getDate() - 1));
      const data: SurveyResearchModel[] = [];
      filteredData.forEach(x => {
        if (x.rate_date.getDate() == date.getDate() && x.rate_date.getMonth() == date.getMonth() && x.rate_date.getFullYear() == date.getFullYear()) {
          data.push(x);
        }
      });
      this.all_survey_change$.next(data);
      return;
    } else if (internal == 'today') {
      date = new Date(date.setHours(0, 0, 0));
    }

    filteredData = filteredData.filter(x => new Date(x.rate_date) >= date);

    if (rate) {
      filteredData = filteredData.filter(x => x.rate == rate);
    }
    filteredData.sort((a, b) => b.rate_date.getTime() - a.rate_date.getTime());
    this.all_survey_change$.next(filteredData);
  }

  filterData(internal: string, rate?: number) {
    let date: Date = new Date();
    if (internal == 'week') {
      date = new Date(date.setDate(date.getDate() - 7));
    } else if (internal == 'month') {
      date = new Date(date.setDate(date.getDate() - 30));
    } else if (internal == 'total') {
      date = new Date(2020, 1, 1, 1, 1, 1, 1);
    } else {
      this.filtered_result_change$.next(this.hotel_survey_change$.getValue());
      return;
    }
    let filteredData;
    filteredData = this.hotel_survey_change$.getValue().filter(x => new Date(x.rate_date) >= date);

    if (rate) {
      filteredData = filteredData.filter(x => x.rate == rate);
    }
    filteredData.sort((a, b) => b.rate_date.getTime() - a.rate_date.getTime());
    this.filtered_result_change$.next(filteredData);
  }
}
